
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// module components
import TariffsUniqueFilters from '@/modules/BillingModule/components/TariffsUniqueFilters/index.vue'

// classes
import { DataState } from '@/core/classes/DataState.class'

// types
import {
    BillingGetIndividualCompaniesParamsT,
    IndividualCompanyT,
} from '@/core/types/billing.types'

// realisations
import { billing } from '@/core/realisations/billing.realisation'

// constants
import { BillingUniqueTariffsColumns } from '@/core/constants/columns/BillingUniqueTariffs.columns'

export default defineComponent({
    components: {
        PageTitle,
        FailedFetch,
        TariffsUniqueFilters,
        TableScrollWrapper,
        TheTable,
        TheButton,
        Cheap,
    },
    setup() {
        const state = reactive(new DataState<IndividualCompanyT>({}))

        const filters_state = reactive({
            search: null as string | null,
            bin: null as string | null,
            //
            limit: 50,
        })

        //

        const loadCompaniesUnique = async (page: number, search?: string) => {
            state.pagination.current_page = page

            try {
                state.is_loading = true

                const params = {
                    page,
                    search,
                    bin: filters_state.bin,
                }

                const response = await billing.getCompaniesUnique(
                    params as BillingGetIndividualCompaniesParamsT
                )
                state.list = response.data
                state.pagination.total_pages = response.meta.last_page
                state.pagination.total_items = response.meta.total

                state.is_failed = false
                state.is_completed = true
            } catch (error) {
                state.failure.catchError(error)

                if (!state.failure.error_state.is_cancel) {
                    state.is_failed = true
                }
            } finally {
                if (!state.failure.error_state.is_cancel) {
                    state.is_loading = false
                }
            }
        }

        const applyFilters = ({ search, bin }: { search: string; bin: string }) => {
            filters_state.search = search
            filters_state.bin = bin

            loadCompaniesUnique(state.pagination.current_page, filters_state.search)
        }

        const resetFilters = () => {
            filters_state.search = null
            filters_state.bin = null

            loadCompaniesUnique(state.pagination.current_page)
        }

        const onLimitChange = (limit: number) => {
            filters_state.limit = limit
            loadCompaniesUnique(state.pagination.current_page)
        }

        const getBillingTitle = (is_billing_enabled: boolean) => {
            return is_billing_enabled ? 'Биллинг включен' : 'Биллинг выключен'
        }

        //

        onBeforeMount(() => {
            loadCompaniesUnique(1)
        })

        //

        return {
            state,
            filters_state,
            //
            applyFilters,
            resetFilters,
            onLimitChange,
            loadCompaniesUnique,
            getBillingTitle,
            //
            BillingUniqueTariffsColumns,
        }
    },
})
